import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { UsersApi } from '@core/api/users/users.api';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime, skip, switchMap } from 'rxjs/operators';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return RequestersComponent; }),
    multi: true
};
var RequestersComponent = /** @class */ (function () {
    function RequestersComponent(fuseTranslationLoaderService, usersApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.usersApi = usersApi;
        this.required = false;
        this.disabled = false;
        this.floatLabel = true;
        this.appearance = 'outline';
        this.requesters = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    RequestersComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.disabled) {
            this.inputValue.disable();
        }
        if (this.required) {
            this.inputValue.setValidators(Validators.required);
        }
        this.inputValue.valueChanges.pipe(skip(1), debounceTime(500), switchMap(function (searchTerm) {
            _this.loading = true;
            _this.requesters = [];
            return _this.usersApi.search({ name_contains: searchTerm, archived: false }, { limit: 1000, orderBy: 'name_asc' });
        })).subscribe(function (response) {
            _this.loading = false;
            _this.requesters = response.items;
        });
    };
    RequestersComponent.prototype.writeValue = function (requesterId) {
        var _this = this;
        if (requesterId) {
            this.usersApi.searchOne(requesterId).subscribe(function (requester) {
                _this.selectedRequester = requester;
                _this.inputValue.setErrors(null);
            });
            return;
        }
        this.deselectRequester();
    };
    RequestersComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    RequestersComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    RequestersComponent.prototype.setSelectedRequester = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.selectedRequester = this.requesters.find(function (requester) { return (requester.id === _this.inputValue.value); });
            this.onChange(this.inputValue.value);
            this.inputValue.setErrors(null);
        }
    };
    RequestersComponent.prototype.deselectRequester = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.inputValue.setErrors(null);
        this.selectedRequester = null;
    };
    return RequestersComponent;
}());
export { RequestersComponent };
